<template>
  <div class="AnotacoesSearch">
    <div class="row d-flex align-items-top m-0 p-0">
      <div class="col-3 form-group m-0 p-0 pr-4">
        <label for="status"
               class="AnotacoesSearch_label m-0 p-0 mb-1">Status</label>
        <v-select id="status"
                  v-model="localData.status"
                  :options="selects.status"
                  :reduce="status => status.value"
                  class="form-control form-control-sm"
                  name="status"
                  placeholder="Selecione" />
      </div>
      <div class="col-3 form-group m-0 p-0 pr-4">
        <label for="tipo_data"
               class="AnotacoesSearch_label m-0 p-0 mb-1">Tipo de data</label>
        <v-select id="tipo_data"
                  v-model="localData.tipo_data"
                  :options="selects.tipo_data"
                  :reduce="tipo_data => tipo_data.value"
                  class="form-control form-control-sm"
                  name="tipo_data"
                  placeholder="Selecione" />
      </div>
      <div v-if="localData.tipo_data"
           class="col-4 form-group m-0 p-0 pr-5">
        <label for="data"
               class="AnotacoesSearch_label m-0 p-0 mb-1">Data</label>
        <div id="data"
             class="d-inline-flex align-items-top">
          <div class="form-group m-0 p-0">
            <input id="inicio"
                   v-model="localData.data_inicial"
                   v-validate="{required: !!localData.tipo_data}"
                   type="date"
                   name="inicio"
                   class="form-control form-control-sm"
                   :class="{'is-invalid': errors.has('inicio')}"
                   :disabled="!localData.tipo_data">
            <span v-if="errors.has('inicio')"
                  class="invalid-feedback">
              {{ localData.tipo_data && !localData.data_inicial ? "Campo obrigatório" : errors.first("inicio") }}
            </span>
          </div>
          <p class="p-0 m-0 mx-2 mt-1 AnotacoesSearch_label">
            até
          </p>
          <div class="form-group m-0 p-0">
            <input id="fim"
                   v-model="localData.data_final"
                   v-validate="{required: !!localData.tipo_data}"
                   type="date"
                   name="fim"
                   class="form-control form-control-sm"
                   :class="{'is-invalid': errors.has('fim')}"
                   :disabled="!localData.tipo_data">
            <span v-if="errors.has('fim')"
                  class="invalid-feedback">
              {{ localData.tipo_data && !localData.data_final ? "Campo obrigatório" : errors.first("fim") }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex align-items-top m-0 p-0 mt-2">
      <div class="col-4 m-0 p-0 pr-4">
        <label for="matricula"
               class="AnotacoesSearch_label  m-0 p-0 mb-1">
          Número da matrícula
        </label>
        <input id="matricula"
               v-model="localData.matricula"
               v-mask="'999999 99 99 9999 9 99999 999 9999999 99'"
               type="text"
               class="form-control form-control-sm"
               @keyup.enter="search()">
      </div>
      <div class="col-8 m-0 p-0">
        <label for="nome"
               class="AnotacoesSearch_label m-0 p-0 mb-1">
          Nome do registrado
        </label>
        <input id="nome"
               v-model="localData.nome_registrado"
               type="text"
               class="form-control form-control-sm"
               @keyup.enter="search()">
      </div>
    </div>
    <div class="col-12 d-flex justify-content-between align-items-center m-0 p-0 mt-3">
      <div class="d-inline-flex">
        <label for=""
               class="AnotacoesSearch_label m-0 p-0 mb-1 mr-3">
          Tipo de registro
        </label>
        <b-form-checkbox :id="`filtro_todos_anotacoes`"
                         v-model="todos_registros"
                         :name="`filtro_todos`"
                         :value="true"
                         class="AnotacoesSearch_tipos text-capitalize mr-4"
                         @change="allTypes">
          Todos
        </b-form-checkbox>
        <b-form-checkbox v-for="(type, index) in listTypes"
                         :id="`filtro_${type.text}_${index}_anotacoes`"
                         :key="index"
                         v-model="localData.tipo_registro"
                         v-validate="'required'"
                         :name="`filtro_${type.text}_${index}_anotacoes`"
                         :value="type.value"
                         :disabled="type.value === 'N'"
                         class="AnotacoesSearch_tipos text-capitalize mr-4"
                         @change="changeSelected">
          <IconSvg v-if="type.icon"
                   :icon="type.icon"
                   class="icon--sm m-0 p-0 AnotacoesSearch_tipos_icon" />
          {{ type.text }}
        </b-form-checkbox>
      </div>
      <button class="btn btn-sm btn-primary px-4"
              @click="search()">
        Filtrar
      </button>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from "vuex"

  export default {
    name: 'SearchAnotacoes',
    data () {
      return {
        localData: {
          // quando for adicionado o C irá ser adicionado tbm o CR
          tipo_registro: ['O', 'C', 'CR'],
          cartorio_id: this.$store.state.auth.cartorio_id,
          tipo: "ANOTACAO",
          status: null,
          tipo_data: null,
          data_inicial: null,
          data_final: null,
          matricula: null,
          nome_registrado: null,
          orderBy: 'data_inclusao',
          perPage: 10
        },
        listTypes: [
          {text: 'nascimento', value: 'N', icon: 'nascimento'},
          {text: 'casamento', value: 'C', icon: 'engagement'},
          {text: 'óbito', value: 'O', icon: 'flower'},
        ],
        selects: {
          status: [
            {label: 'Todas não cumpridas', value: null},
            {label: 'Vencidas', value: 'VENCIDA'},
            {label: 'A vencer', value: 'A_VENCER'},
            {label: 'Todas cumpridas', value: 'CUMPRIDA'},
          ],
          tipo_data: [
            { label: 'Qualquer data', value: null },
            { label: 'Data Inclusão', value: 'data_inclusao' },
            { label: 'Data Registro', value: 'data_registro' },
            { label: 'Data Cumprimento', value: 'data_cumprimento' }
          ],
        },
        todos_registros: true
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      })
    },
    methods: {
      async search () {
        if (!this.localData.tipo_registro.length) {
          this.$emit('showError', '', 'Escolha o tipo de registro.')
        }

        const valid = await this.$validator.validate()

        if (!valid) return

        this.$emit('search', this.localData)
      },
      allTypes (value) {
        setTimeout(() => {
          if (value) {
            this.localData.tipo_registro = ['O', 'C', 'CR']
          } else {
            this.localData.tipo_registro = []
          }
        }, 100)
      },
      changeSelected (value) {
        setTimeout(() => {
          if (!value && this.todos_registros) this.todos_registros = false

          /**
           * Quando o tipo de registro C for selecionados, adicionamos na lista o tipo CR
           * para também trazer tipo religioso
           */
          const tipoCasamento = this.localData.tipo_registro.find(tipo => tipo === 'C')
          const tipoCasamentoReligioso = this.localData.tipo_registro.find(tipo => tipo === 'CR')

          if (tipoCasamento && !tipoCasamentoReligioso) {
            this.localData.tipo_registro.push('CR')
          } else if (tipoCasamentoReligioso && !tipoCasamento) {
            this.localData.tipo_registro.splice(this.localData.tipo_registro.indexOf('CR'), 1)
          }

          if (this.localData.tipo_registro.length > 2) this.todos_registros = true
          else this.todos_registros = false
        }, 100)
      }
    }
  }
</script>
<style lang="scss">
  .AnotacoesSearch {
    &_label {
      font-size: 16px;
      font-weight: 500;
      color: #373a3c;
    }

    &_tipos {
      font-size: 16px;
      font-weight: normal;
      color: #000000;

      &_icon {
        width: 18px;
        height: 18px;
      }
    }
  }
</style>
